import { TThunkAction } from '../../types/redux';
import {
  fetchValidatePhone,
  IValidatePhoneResponse200,
  IValidatePhoneResponse400,
} from '../../repositories/demand/v1/validate-phone';
import { EPhoneVerificationStatus } from '../../constants/phoneVerificationStatus';

export interface IValidatePhoneParams {
  /** Код для подтверждения номера телефона **/
  code?: string | null;
  /** Номер телефона в формате +79991234567 **/
  phone: string;
}

export interface IValidatePhoneResult {
  /** Время до следующей отправки кода подтверждения **/
  confirmTimeout?: number | null;
  /** Статус подтверждения телефона **/
  status: EPhoneVerificationStatus;
}

export const requestValidatePhone = (parameters: IValidatePhoneParams): TThunkAction<Promise<IValidatePhoneResult>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    try {
      const validateData = await fetchValidatePhone<IValidatePhoneResponse200, IValidatePhoneResponse400>({
        httpApi,
        parameters,
      });

      if (validateData.statusCode === 200) {
        return {
          confirmTimeout: validateData.response.confirmTimeout,
          status: validateData.response.status as unknown as EPhoneVerificationStatus,
        };
      } else {
        logger.error('Invalid sms validation request');

        return {
          status: EPhoneVerificationStatus.SendError,
        };
      }
    } catch (error) {
      logger.error('Unable to send sms validation request', error);

      return {
        status: EPhoneVerificationStatus.SendError,
      };
    }
  };
};
